export default __webpack_public_path__ + "static/media/bg-img-md.b1098a52.png";